var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"miter","strokeLinecap":"square"},[React.createElement("path",{"d":"M3.0562 16.5497L16.4355 3.1704l3.394 3.3941L6.4504 19.9438zM.8277 18.7782l1.1228-1.1228 3.3941 3.394-1.1228 1.1229z","key":0}),React.createElement("path",{"d":"M17.9236 2.4472L21.82 1.2184l-1.2053 3.9199-2.6911-2.6911z","key":1})]));
}

Edit.defaultProps = {"width":"23","height":"23"};

module.exports = Edit;

Edit.default = Edit;



//////////////////
// WEBPACK FOOTER
// ./src/icons/edit.svg
// module id = 296
// module chunks = 0